<template lang="pug">
.panel.panel-default
  .panel-heading.panel-title Details
    .text-center.loading(v-if="loading")
      i.fa.fa-spinner.fa-pulse.fa-spin
  .panel-body(v-if="!loading")
    .container-fluid
      .row(v-if="channel.type")
        label.col-sm-2 Type
        .col-sm-4(v-if="channel.type==='web'")
          span.pr5 Web
          i.fa.fa-globe
        .col-sm-4(v-if="channel.type==='sms'")
          span.pr5 Sms
          i.fa.fa-phone
      .row(v-if="channel.alias")
        label.col-sm-2 Alias
        .col-sm-4 {{channel.alias}}
      .row(v-if="channel.phonenumber")
        label.col-sm-2 Number
        .col-sm-4 {{channel.phonenumber}}
      .row(v-if="channel.prefix")
        label.col-sm-2 Prefix
        .col-sm-4 {{channel.prefix}}
      .row()
        label.col-sm-2 Invalid Message
        .col-sm-4(v-if="channel.invalidMessage") {{channel.invalidMessage}}
        em.col-sm-4.text-muted(v-else) not set
      .row
        label.col-sm-2 Code Config
        .col-sm-4(v-if="codeConfig") {{ codeConfig }}
        em.col-sm-4.text-muted(v-else) global code config
      hr
      .row
        label.col-sm-2 Owners
        .col-sm-10
          PillsList(v-if="owners" :items="owners")

</template>

<script>
import PillsList from '@/components/common/PillsList'

export default {
  props: {
    loading: {
      type: Boolean
    },
    channel: {
      type: Object,
      required: true
    },
    codeConfig: {
      type: String
    }
  },
  computed: {
    owners() {
      return this.channel.owner.map((c) => ({ name: c.organization.name }))
    }
  },
  components: {
    PillsList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/validation/entrychannel/EntrychannelDetails.vue